'use client';

import { Box, CircularProgress, Typography } from '@mui/material';

interface FullScreenLoaderProps {
  message?: string;
  subtext?: string;
}

export default function FullScreenLoader({ message, subtext }: FullScreenLoaderProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        color: 'text.primary',
        px: 2
      }}
      role="main"
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress color="primary" sx={{ mb: 2 }} />
        {message && (
          <Typography variant="body1" color="text.secondary" aria-live="polite">
            {message}
          </Typography>
        )}
        {subtext && (
          <Typography variant="caption" color="text.disabled" display="block" sx={{ mt: 0.5 }}>
            {subtext}
          </Typography>
        )}
      </Box>
    </Box>
  );
}


